export class BmsCustomerFlag {
  id : number;
  customerId : string;
  nodeId : number;
  flagId : string;
  status : number;
  modifiedAt : Date;
}
